/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Passkey_AddingInputs */



/**
* | output |
* | --- |
* | "Adding..." |
*
* @param {Profile_Passkey_AddingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_passkey_adding = /** @type {((inputs?: Profile_Passkey_AddingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Passkey_AddingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajout...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregando...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicionando...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiunta...")
	return /** @type {LocalizedString} */ ("Adding...")
});